import React from "react";

const Icon = ({src, alt, style={}}) => {
    return <img style={{...style, width: 26, height: 26}} src={src} alt={alt} />
};

export default Icon;